module.exports = __webpack_public_path__ + "assets/reg-card-teacher-2.ae294aaf.svg";